// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* COLORS */
/* MEASUREMENTS */
.groupTask[data-v-dbc9e542] {
  font-weight: 600;
}
[data-v-dbc9e542] .other-user-task td.assignee-td {
  font-weight: 100;
  opacity: 0.6;
}
[data-v-dbc9e542] .userTask {
  font-weight: 600;
}
[data-v-dbc9e542] .userTask:before {
  font-size: 1.1em;
}
.icon[data-v-dbc9e542]:before {
  margin-right: 5px;
  margin-top: 2px;
}
.test-mode[data-v-dbc9e542] {
  background: #ddd;
}
.tag-filters.has-error li[data-v-dbc9e542] {
  position: relative;
}
.tag-filters.has-error li .badge-pill.btn-primary[data-v-dbc9e542]:before {
  content: "At least one filter must be selected";
  position: absolute;
  top: 100%;
  left: 0;
  pointer-events: none;
  width: max-content;
  background: #ffffff;
  max-width: 300px;
  border: 1px solid #cccccc;
  padding: 7.5px;
  color: #212121;
  text-align: center;
  display: inline-block;
  border-radius: 3px;
  font-size: 14px;
  font-weight: normal;
  z-index: 200000;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2);
  -moz-box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2);
  -webkit-box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2);
}
`, "",{"version":3,"sources":["webpack://./../Index.3.vue","webpack://./admin/pages/Tasks/Index.3.vue"],"names":[],"mappings":"AAAA,WAAW;AACX,iBAAiB;ACCjB;EACI,gBAAA;ADCJ;ACCA;EAEQ,gBAAA;EACA,YAAA;ADAR;ACGA;EACI,gBAAA;ADDJ;ACEI;EACI,gBAAA;ADAR;ACII;EACI,iBAAA;EACA,eAAA;ADFR;ACKA;EACI,gBAAA;ADHJ;ACMI;EACI,kBAAA;ADJR;ACGI;EAGQ,+CAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,oBAAA;EACA,kBAAA;EAGA,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,cAAA;EACA,cAAA;EACA,kBAAA;EACA,qBAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,eAAA;EACA,0CAAA;EACA,+CAAA;EACA,kDAAA;ADLZ","sourcesContent":["/* COLORS */\n/* MEASUREMENTS */\n.groupTask {\n  font-weight: 600;\n}\n::v-deep .other-user-task td.assignee-td {\n  font-weight: 100;\n  opacity: 0.6;\n}\n::v-deep .userTask {\n  font-weight: 600;\n}\n::v-deep .userTask:before {\n  font-size: 1.1em;\n}\n.icon:before {\n  margin-right: 5px;\n  margin-top: 2px;\n}\n.test-mode {\n  background: #ddd;\n}\n.tag-filters.has-error li {\n  position: relative;\n}\n.tag-filters.has-error li .badge-pill.btn-primary:before {\n  content: \"At least one filter must be selected\";\n  position: absolute;\n  top: 100%;\n  left: 0;\n  pointer-events: none;\n  width: max-content;\n  background: #ffffff;\n  max-width: 300px;\n  border: 1px solid #cccccc;\n  padding: 7.5px;\n  color: #212121;\n  text-align: center;\n  display: inline-block;\n  border-radius: 3px;\n  font-size: 14px;\n  font-weight: normal;\n  z-index: 200000;\n  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2);\n  -moz-box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2);\n  -webkit-box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2);\n}\n","\n@import \"/lib/Colors.less\";\n.groupTask {\n    font-weight: 600;\n}\n::v-deep .other-user-task {\n    td.assignee-td {\n        font-weight: 100;\n        opacity: 0.6;\n    }\n}\n::v-deep .userTask {\n    font-weight: 600;\n    &:before {\n        font-size: 1.1em;\n    }\n}\n.icon {\n    &:before {\n        margin-right: 5px;\n        margin-top: 2px;\n    }\n}\n.test-mode {\n    background: #ddd;\n}\n.tag-filters {\n    &.has-error li {\n        position: relative;\n        .badge-pill.btn-primary:before {\n            content: \"At least one filter must be selected\";\n            position: absolute;\n            top: 100%;\n            left: 0;\n            pointer-events: none;\n            width: max-content;\n\n            // .popper\n            background: #ffffff;\n            max-width: 300px;\n            border: 1px solid #cccccc;\n            padding: 7.5px;\n            color: #212121;\n            text-align: center;\n            display: inline-block;\n            border-radius: 3px;\n            font-size: 14px;\n            font-weight: normal;\n            z-index: 200000;\n            box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2);\n            -moz-box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2);\n            -webkit-box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2);\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
